export default function(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-interpolate/src/constant.js
// module id = 149
// module chunks = 0